import { commonjsGlobal as r } from "./index168.js";
import { __exports as e } from "./index174.js";
import "./index182.js";
import "./index183.js";
import { __exports as m } from "./index184.js";
import { __exports as f } from "./index185.js";
var i = r && r.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(e, "__esModule", { value: !0 });
e.default = p;
var s = i(m), n = f, u = /<(![a-zA-Z\s]+)>/;
function p(t) {
  if (typeof t != "string")
    throw new TypeError("First argument must be a string");
  if (!t)
    return [];
  var o = t.match(u), a = o ? o[1] : void 0;
  return (0, n.formatDOM)((0, s.default)(t), null, a);
}
